import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'wsd-extended-card',
  templateUrl: './extended-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./extended-card.component.css']
})
export class ExtendedCardComponent {

  @Input()
  title: string;

  @Input()
  loading: boolean;

  @Input()
  info: boolean = false;

  @Input()
  expanded: boolean = null;

  @Input()
  redirectTo: any;

  @Output()
  infoClicked = new EventEmitter<any>();

  @Output()
  sizeChanged = new EventEmitter<any>();

  constructor() {
  }

}
